import pluralize from 'pluralize'

export const BULK_UPDATE_STATUS_MODAL_LABELS = {
  TITLE: 'Update controls validation status',
  SUBTITLE: (count: number) => `${pluralize('control', count, true)} selected`,
  PRIMARY_BUTTON: 'Update',
  VALIDATION_STATUS_LABEL: 'Validation status',
  KEEP_AS_IS_OPTION: 'Keep as is',
  CANT_BE_UNDONE: "Can't be undone after saving",
  ADD_COMMENT_LABEL: 'Add a comment',
  ADD_COMMENT_OPTIONAL: '(optional)',
  COMMENT_PLACEHOLDER: 'Visible in activity log for audit purposes',
  SUCCESS_TITLE: 'Bulk update completed!',
  SUCCESS_DESCRIPTION: (count: number) => `Updated ${pluralize('control', count, true)}`,
  ERROR_TITLE: 'Failed to update status',
  ERROR_DESCRIPTION: 'Please try again later.',
} as const
